<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row our-story-section">
          <div class="col-xl-5 col-12 mt-2 order-xl-1 order-2 col-sm-5 mt-sm-5 mt-xl-0 col-md-5 mt-md-0">
            <div class="w-100 d-inline-block about-us-image mt-sm-5 mt-xl-0 mt-3">
              <img class="w-100" v-lazy="require('@/assets/images/grooming-services-mobile-grooming-service.webp')" alt="grooming services, mobile grooming service">
            </div>
          </div>
          <div class="col-xl-7 col-12 order-xl-2 order-1 col-sm-7 col-md-7">
            <div class="w-100 d-inline-block margin-xl-top-1">
              <p class="fw-bold nav-color text-uppercase text-size-14 mb-0 family-filson-bold margin-xl-top-3 text-full-14">
                About Us
              </p>
              <h2 class="text-black fw-bold family-filson-bold margin-xl-bottom-3 text-size-24 text-full-24">Our Story</h2>
            </div>
            <div class="w-100 d-inline-block rounded-4 bg-white box-shadow pets-about-box mt-xl-0 mt-1">
              <p class="mb-0 text-size-14 text-black family-inter-light text-full-13">
                Being animal lovers ourselves, we are aware of the fact that your pet holds a unique place in your heart. Therefore, we are offering a comprehensive range of mobile pet grooming services, designed to cater unique needs and preferences of every furry companion. We have been grooming for many years now, and we love every part of our job! We provide a very warm and friendly environment for your pets. Our professional team makes sure your pet always gets the highest level of care.
              </p>
              <div class="row margin-top-3">
                <div class="col-xl-4 col-5 margin-top-3 pr-xs-0 col-md-4">
                  <div class="w-100 d-inline-block">
                    <router-link class="text-white text-size-11 d-inline-block book-btn bg-green inter-semi-bold text-uppercase text-full-11" to="/booking/">
                      <img class="me-2 h-16" v-lazy="require('@/assets/images/book-online-icon.svg')" alt="picture">
                    Book Online
              </router-link>
                  </div>
                </div>
                <div class="col-xl-4 col-7 margin-top-3 col-md-5 ps-xl-0">
                  <div class="w-100 d-inline-block margin-top-1">
                    <!-- <a class="nav-color text-size-13 fw-bold family-filson-bold text-full-12 text-uppercase" 
                    href="javascript:void(0)" @click="openCall">
                      <img class="me-2 call-calling-icon" src="@/assets/images/call-calling.svg" alt="picture" />
                      Schedule a call
                    </a> -->
                  </div>
                </div>
                <div class="col-xl-4 col-12 d-xl-block d-none col-md-3 d-md-block ps-xl-0">
                  <div class="w-100 d-inline-block text-center pet-under-story">
                    <a href="javascript:void(0)">
                      <img v-lazy="require('@/assets/images/cat-dog-birds-icon-image.webp')" alt="pet grooming at home, pet grooming tools">
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "petsintroductionComponent.vue",
    methods: {
       async openCall() {
        // console.log("Call link clicked");
    
        // First, call the API to store the click data
        await this.callClick('call');
    
        // Then open the phone app
        const phoneNumber = "+971522809076";
        const telUrl = `tel:${phoneNumber}`;
        window.open(telUrl, "_blank");
      },  
      async callClick(method) {
       try {
        const payload = {
          website_name: this.$websiteName,
          type: method,
          ip: 'call',
        
        };
        const response = await this.$axios.post('/click-count', payload);
        console.log('Response:', response.data);
        
      } catch (err) {
        console.error('Error during call click:', err);
      }
    },
            openWhatsApp() {
    // Define your phone number and message
    const phoneNumber = "+971522809076"; // Replace with your phone number in international format
    const message = "Hello, I am Looking for Grooming Services"; // Replace with your custom message

    // Encode the message for URL compatibility
    const encodedMessage = encodeURIComponent(message);

    // Construct the WhatsApp URL
    const whatsappUrl = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodedMessage}&type=phone_number&app_absent=0`;

    // Open the URL in a new tab/window
    window.open(whatsappUrl, "_blank");
  },
    },
  };
</script>

<style scoped></style>
